import Avatar from "react-avatar";
import { useIntl } from "react-intl";
import { CellFlag, CellTags } from "src/app/components";
import { columnParForDates } from "src/app/components/grid/GridHelpers";
import { SimpleEntityGridColumn } from "src/app/components/grid/SimpleEntityGrid";
import { linksColumn } from "src/app/utils/aggrid/ColumnsStyles";

export default function useProcessGridColumns() {
    const { formatMessage } = useIntl();

    const gridColumns: Array<SimpleEntityGridColumn> = [
        {
            field: "id",
            filter: "agNumberColumnFilter",
            cellClass: "number-cell",
            minWidth: 60,
            maxWidth: 60,
            hide: true,
        },
        {
            field: "publishedAt",
            headerName: formatMessage({ id: "process.grid.col.publishedAt" }),
            ...columnParForDates("publishedAt"),
            minWidth: 100,
            maxWidth: 100,
        },
        {
            field: "manager",
            headerName: formatMessage({ id: "content.grid.col.manager" }),
            autoHeight: true,
            valueGetter: ({ data }) => data?.manager,
            cellRenderer: ({ data }: any) => (
                <>
                    {data.manager && (
                        <div>
                            <Avatar
                                round
                                size="24px"
                                fgColor={"var(--kt-secondary-inverse)"}
                                color={"var(--kt-secondary)"}
                                textSizeRatio={2}
                                name={data?.manager}
                            />
                        </div>
                    )}
                </>
            ),
            filter: "agSetColumnFilter",
            minWidth: 60,
            maxWidth: 60,
        },
        {
            field: "lang",
            autoHeight: true,
            filter: "agSetColumnFilter",
            valueGetter: ({ data }) => (data.lang ? `${data.lang}` : ""),
            cellRenderer: ({ data }: any) => <CellFlag lang={data?.lang} />,
            minWidth: 50,
            maxWidth: 50,
        },
        {
            field: "moneySite",
            headerName: formatMessage({ id: "content.grid.col.moneySite" }),
            filter: "agMultiColumnFilter",
            minWidth: 260,
            maxWidth: 260,
        },

        {
            field: "deliveredAt",
            headerName: formatMessage({ id: "content.grid.col.deliveredAt" }),
            ...columnParForDates("deliveredAt"),
            minWidth: 90,
            maxWidth: 90,
            hide: true,
        },
        {
            field: "thematic",
            headerName: formatMessage({ id: "content.grid.col.thematic" }),
            minWidth: 107,
            maxWidth: 107,
        },
        {
            field: "wordCount",
            headerName: formatMessage({ id: "content.grid.col.wordCount" }),
            filter: "agNumberColumnFilter",
            cellClass: "number-cell",
            minWidth: 65,
            maxWidth: 65,
        },
        {
            field: "orderPrice",
            headerName: formatMessage({ id: "content.grid.col.orderPrice" }),
            valueFormatter: ({ data }: any) => `${data.orderPrice} €`,
            filter: "agNumberColumnFilter",
            cellClass: "number-cell",
            minWidth: 80,
            maxWidth: 80,
        },
        {
            field: "writingType",
            headerName: formatMessage({ id: "content.grid.col.contentType" }),
            valueGetter: ({ data }: any) =>
                `${formatMessage({
                    id: `content.grid.col.contentType.${data.contentType}`,
                })} ${formatMessage({
                    id: `content.grid.col.writingType.${data.writingType}`,
                })}`,
            minWidth: 100,
            maxWidth: 100,
        },

        {
            field: "keywords",
            autoHeight: true,
            headerName: formatMessage({ id: "content.grid.col.keyword" }),
            valueGetter: ({ data }: any) => data?.keywords,
            cellRenderer: ({ data }: any) => <CellTags tags={data?.keywords} />,
            width: 300,
        },
        {
            field: "links",
            autoHeight: true,
            headerName: formatMessage({ id: "content.grid.col.links" }),
            ...linksColumn(),
            width: 360,
            hide: true,
        },
        {
            field: "commentForLinker",
            headerName: formatMessage({ id: "content.grid.col.commentForLinker" }),
        },
        {
            field: "createdAt",
            headerName: formatMessage({ id: "content.grid.col.createdAt" }),
            ...columnParForDates("createdAt"),
            minWidth: 130,
            maxWidth: 130,
            hide: true,
        },
        {
            field: "updatedAt",
            headerName: formatMessage({ id: "content.grid.col.updatedAt" }),
            ...columnParForDates("updatedAt"),
            minWidth: 130,
            maxWidth: 130,
            hide: true,
        },
    ];
    return gridColumns;
}
